export default __webpack_public_path__ + "static/speedup-research-76698fd093df4627521690cee01a641f.svg";